const UTILS = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  }
};

(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductGroups', () => ({
      selectors: {
        session_groups: 'PRODUCT_GROUPS'
      },
      mounted() {
        let am = this;
        let SESSION_PRODUCT_GROUPS = JSON.parse(sessionStorage.getItem(am.selectors.session_groups));
        if (SESSION_PRODUCT_GROUPS && false) {
          // window.PRODUCT_GROUPS = SESSION_PRODUCT_GROUPS;
          // document.dispatchEvent(new CustomEvent('product-groups-loaded'));
        }
        else {
          (async () => {
            let res = await fetch('/?sections=product-groups').then(res => res.json());
            let $res = UTILS.ConvertStringToHTML(res['product-groups']);
            UTILS.ConvertStringToJS($res.querySelector('[data-product_groups]').innerHTML);
            sessionStorage.setItem(am.selectors.session_groups, JSON.stringify(PRODUCT_GROUPS))
            document.dispatchEvent(new CustomEvent('product-groups-loaded'));
          })();  
        }
      }
    }));

    Alpine.data('ColorSwatches', () => ({
      mounted() {
        let am = this;
        am.LoadSwatches();
        document.addEventListener('product-groups-loaded', am.LoadSwatches.bind(am));
      },
      LoadSwatches() {
        if (typeof PRODUCT_GROUPS == 'undefined') return;

        let am = this;
        let product_handle = am.$el.dataset.product;
        let group = PRODUCT_GROUPS.find(group => {
          return group.products.map(p => p.handle.join('')).indexOf(product_handle) !== -1;
        });

        // console.log(group)
        // if matching group, add swatches
        if (group) {
          let products = group.products.filter(item => item.handle.indexOf(product_handle) == -1);

          products.forEach((item, index) => { 
            am.$el.insertAdjacentHTML('beforeend', item.color_swatch);
            if (index == products.length - 1) {
              am.$el.removeAttribute('x-cloak-op')
            }
          });
        }
        else {
          am.$el.removeAttribute('x-cloak-op');
        }
      }
    }));
  });
})();